/* eslint-disable @typescript-eslint/camelcase */

import * as t from 'io-ts';
import { SetFromPlace } from '../types';

export const Empty = t.type({});

export const CityToken = Empty;

export const Offer = Empty;

export const CabType = t.type({
  type: t.string,
  image: t.string
});
export type CabType = t.TypeOf<typeof CabType>;
export const KnowMoreDetails = t.type({
  header: t.string,
  description: t.string,
  claim_process_label: t.string,
  claim_process_steps: t.array(t.string)
});
export type KnowMoreDetails = t.TypeOf<typeof KnowMoreDetails>;
export const BPG = t.type({
  header: t.string,
  description: t.string,
  know_more_label: t.string,
  know_more_details: KnowMoreDetails
});
export type BPG = t.TypeOf<typeof BPG>;
export const Persuasion = t.type({
  text: t.union([t.string, t.null, t.undefined]),
  highlighted_text: t.union([t.string, t.null, t.undefined]),
  highlight_color: t.union([t.string, t.null, t.undefined]),
  tag: t.union([t.string, t.null, t.undefined]),
  tag_icon_url: t.union([t.string, t.null, t.undefined]),
  icon_url: t.union([t.string, t.null, t.undefined]),
  tag_gradient: t.union([t.string, t.null, t.undefined]),
  title: t.union([t.string, t.null, t.undefined]),
  tooltip_icon: t.union([t.string, t.null, t.undefined]),
  tooltip_text: t.union([t.string, t.null, t.undefined])
});
export const PackageTitlte = t.type({
  title_word: t.union([t.string, t.null, t.undefined]),
  superscript_text: t.union([t.string, t.null, t.undefined])
});

export const Package = t.type({
  mySafety: t.boolean,
  category_id: t.union([t.string, t.null, t.undefined]),
  type: t.union([t.string, t.null, t.undefined]),
  total_amount: t.union([t.number, t.null, t.undefined]),
  total_inclusive_amount: t.union([t.number, t.null, t.undefined]),
  included_kms: t.union([t.number, t.null, t.undefined]),
  strike_off_amount: t.union([t.number, t.null, t.undefined]),
  strike_off_discount: t.union([t.number, t.null, t.undefined]),
  tolls_and_taxes_text: t.union([t.string, t.null, t.undefined]),
  full_payable_amount: t.union([t.number, t.undefined, t.null]),
  vehicle_model_type_string: t.union([t.string, t.null, t.undefined]),
  model_description: t.union([t.string, t.null, t.undefined]),
  overall_rating: t.union([t.number, t.null, t.undefined]),
  rating_count: t.union([t.number, t.null, t.undefined]),
  rating_show: t.union([t.boolean, t.null, t.undefined]),
  no_of_seats: t.union([t.number, t.null, t.undefined]),
  no_of_luggage: t.union([t.number, t.null, t.undefined]),
  ac_string: t.union([t.string, t.null, t.undefined]),
  strike_off_discount_textV2: t.union([t.string, t.null, t.undefined]),
  strike_off_discount_text: t.union([t.string, t.null, t.undefined]),
  vehicle_model: t.union([t.string, t.null, t.undefined]),
  inclusive_message: t.union([t.string, t.null, t.undefined]),
  is_my_safety: t.union([t.boolean, t.null, t.undefined]),
  package: t.union([t.string, t.null, t.undefined]),
  safety_variant: t.union([t.string, t.null, t.undefined]),
  fuel_type: t.union([t.string, t.null, t.undefined]),
  vehicle_model_type: t.union([t.string, t.null, t.undefined]),
  title: t.union([t.string, t.null, t.undefined]),
  subtitle: t.union([t.string, t.null, t.undefined]),
  persuasions: t.union([t.null, t.undefined, t.array(Persuasion)]),
  mobile_persuasions: t.union([t.null, t.undefined, t.array(Persuasion)]),
  cab_description: t.union([t.string, t.null, t.undefined]),
  package_title: t.array(PackageTitlte),
  mysafety_kit_available: t.union([t.boolean, t.null, t.undefined]),
  vendor_name: t.union([t.string, t.null, t.undefined]),
  reviewURL: t.union([t.string, t.null, t.undefined])
});
export type Persuasion = t.TypeOf<typeof Persuasion>;
export type TripBenefit = t.TypeOf<typeof TripBenefit>;
export const TripBenefit = t.type({
  icon: t.union([t.string, t.null, t.undefined]),
  subTitle: t.union([t.string, t.null, t.undefined]),
  title: t.union([t.string, t.null, t.undefined])
});
export const CabData = t.type({
  distance: t.union([t.undefined, t.string]),
  duration: t.union([t.undefined, t.string]),
  route: t.union([t.number, t.undefined, t.string]),
  oneway_distance_in_kms: t.union([t.number, t.undefined, t.null]),
  oneway_duration_in_minutes: t.union([t.number, t.undefined, t.null]),
  total_amount: t.union([t.number, t.undefined, t.null]),
  highlighted_price: t.union([t.number, t.undefined, t.null]),
  per_km_charge: t.union([t.null, t.number, t.undefined]),
  included_kms: t.union([t.null, t.number, t.undefined]),
  redirection_url: t.union([t.string, t.undefined]),
  reviewURL: t.union([t.string, t.undefined, t.null]),
  best_price_guarantee_details: t.union([BPG, t.null, t.undefined]),
  strike_off_amount: t.union([t.number, t.null, t.undefined]),
  seoUrl: t.union([t.undefined, t.null, t.string]),
  sourceCity: t.union([t.undefined, t.null, t.string]),
  destinationCity: t.union([t.undefined, t.null, t.string]),
  inclusive_message: t.union([t.undefined, t.null, t.string]),
  vehicle_model: t.union([t.string, t.undefined, t.null]),
  type: t.union([t.string, t.undefined, t.null]),
  model_name: t.union([t.string, t.undefined, t.null]),
  model_description: t.union([t.string, t.undefined, t.null]),
  overall_rating: t.union([t.string, t.undefined, t.null, t.number]),
  rating_count: t.union([t.string, t.undefined, t.null, t.number]),
  image_url: t.union([t.string, t.undefined, t.null]),
  seat_count: t.union([t.number, t.undefined, t.null]),
  luggage_count: t.union([t.number, t.undefined, t.null]),
  tolls_and_taxes_text: t.union([t.undefined, t.null, t.string]),
  image: t.union([t.string, t.undefined, t.null]),
  utilities: t.union([t.array(t.string), t.null, t.undefined]),
  total_inclusive_amount: t.union([t.number, t.undefined, t.null]),
  full_payable_amount: t.union([t.number, t.undefined, t.null]),
  cab_description: t.union([t.string, t.undefined, t.null]),
  cab_description_mweb: t.union([t.string, t.undefined, t.null]),
  strike_off_discount_textV2: t.union([t.string, t.undefined, t.null]),
  strike_off_discount_text: t.union([t.string, t.undefined, t.null]),
  strike_off_discount: t.union([t.number, t.undefined, t.null]),
  my_safety: t.union([t.boolean, t.undefined, t.null]),
  rating_show: t.union([t.boolean, t.undefined, t.null]),
  fuel_type: t.union([t.string, t.undefined, t.null]),
  category_id: t.union([t.string, t.undefined, t.null]),
  vehicle_model_type: t.union([t.string, t.undefined, t.null]),
  package: t.union([t.string, t.undefined, t.null]),
  safety_variant: t.union([t.string, t.undefined, t.null]),
  vendor_name: t.union([t.string, t.undefined, t.null]),
  is_mysafety_kit_available: t.union([t.boolean, t.undefined, t.null]),
  cab_description_v2: t.union([t.string, t.undefined, t.null]),
  packages: t.union([t.array(Package), t.undefined, t.null]),
  trip_benifits: t.union([t.array(TripBenefit), t.undefined, t.null]),
  mobile_persuasions: t.union([t.null, t.undefined, t.array(Persuasion)]),
  cityName: t.union([t.string, t.undefined, t.null])
});

export type CabData = t.TypeOf<typeof CabData>;
export const Cabs = t.type({
  HATCHBACK: t.array(CabData),
  SEDAN: t.array(CabData),
  SUV: t.array(CabData)
});
export const TopRoutes = t.type({
  cabTypes: t.array(CabType),
  cabs: t.union([Cabs, Empty])
});

export type TopRoutes = t.TypeOf<typeof TopRoutes>;

export const PackageUnit = t.type({
  duration: t.union([t.null, t.undefined, t.string]),
  distance: t.union([t.null, t.undefined, t.string]),
  cab_list: t.array(CabData)
});
export const CabTypesAvailableForRent = t.type({
  request: t.union([t.null, t.undefined]),
  errors: t.union([t.null, t.undefined]),
  status: t.union([t.string, t.undefined]),
  packages: t.union([t.array(PackageUnit), t.undefined])
});

export type CabTypesAvailableForRent = t.TypeOf<
  typeof CabTypesAvailableForRent
>;
export const CabRentalPrice = t.type({
  type: t.string,
  image: t.union([t.string, t.null]),
  vehicle_model: t.string,
  utilities: t.union([t.array(t.string), t.null]),
  inclusive_message: t.null,
  total_amount: t.number,
  similar_message: t.union([t.null, t.string]),
  per_km_charge: t.union([t.null, t.number]),
  included_kms: t.union([t.null, t.number]),
  seoUrl: t.union([t.undefined, t.null, t.string])
});
export type CabRentalPrice = t.TypeOf<typeof CabRentalPrice>;

export const OtherCityData = t.type({
  name: t.string,
  url: t.string,
  code: t.union([t.string, t.null, t.undefined])
});
export const Breadcrumb = t.type({
  displayString: t.string,
  redirectionUrl: t.string
});
export type Breadcrumb = t.TypeOf<typeof Breadcrumb>;
export const Faq = t.type({
  question: t.string,
  answer: t.string
});
export type Faq = t.TypeOf<typeof Faq>;
export const Usp = t.type({
  id: t.union([t.number, t.null, t.undefined]),
  created: t.union([t.string, t.null, t.undefined]),
  modified: t.union([t.string, t.null, t.undefined]),
  uspTitle: t.string,
  uspDescription: t.string,
  logoUrl: t.string,
  logoDTUrl: t.union([t.string, t.null, t.undefined])
});

export const UspInfo = t.type({
  uspTitle: t.union([t.string, t.null, t.undefined]),
  uspDescription: t.string,
  logoUrl: t.string
});

export type Usp = t.TypeOf<typeof Usp>;

export type UspInfo = t.TypeOf<typeof UspInfo>;

export const Template = t.type({
  id: t.number,
  created: t.string,
  modified: t.string,
  templateName: t.string,
  metaTitle: t.string,
  metaDescription: t.string,
  metaKeywords: t.string,
  analytics: t.string,
  noOfListings: t.union([t.number, t.null]),
  footerData: t.string,
  h1Title: t.string,
  breadcrumb: t.array(Breadcrumb),
  bannerDesktop: t.union([t.string, t.null]),
  bannerMobile: t.union([t.null, t.string]),
  sampleUrl: t.string,
  subTitle: t.string,
  externalJs: t.string,
  extraInfo: t.string,
  faq: t.array(Faq),
  usps: t.array(Usp),
  descriptionInHtml: t.union([t.string, t.null, t.undefined])
});
export type Template = t.TypeOf<typeof Template>;
export const MySafetyHtmls = t.type({
  infoMessage: t.string,
  mySafetyUsp: t.string,
  ePassUsp: t.string,
  stateGuidelines: t.string
});
export const OperatorDataChecker = t.type({
  id: t.number,
  name: t.string,
  description: t.union([t.string, t.null])
});

export type OperatorData = t.TypeOf<typeof OperatorDataChecker>;

export const OtherRouteOperatorUrls = t.type({
  sourceCityName: t.string,
  destinationCityName: t.string,
  operatorName: t.string,
  url: t.union([t.string, t.null])
});

export const RouteInfo = t.type({
  sourceCityName: t.string,
  destinationCityName: t.string,
  routeUrl: t.union([t.string, t.null, t.undefined]),
  url: t.union([t.string, t.null, t.undefined]),
  seoUrl: t.union([t.string, t.null, t.undefined])
});

export const RouteCarTypeInfo = t.type({
  seoUrl: t.string,
  sourceCityName: t.string,
  destinationCityName: t.string,
  carType: t.string
});

export const NameUrl = t.type({
  name: t.union([t.string, t.null, t.undefined]),
  url: t.union([t.string, t.null, t.undefined])
});

export const LeaveIntentOffer = t.type({
  title: t.string,
  description: t.string,
  couponCode: t.string
});
export type LeaveIntentOffer = t.TypeOf<typeof LeaveIntentOffer>;

export const CityOperators = t.type({
  url: t.union([t.string, t.null, t.undefined]),
  cityName: t.string,
  operatorName: t.string
});
export const cabsAggregatorData = t.type({
  routeOperators: t.array(OtherRouteOperatorUrls),
  operatorsInACity: t.array(CityOperators)
});

export const HotelsInfoType = t.type({
  name: t.string,
  count: t.union([t.number, t.string, t.null, t.undefined]),
  label: t.string,
  url: t.string
});

export const RydeAvailabilityInfoType = t.type({
  rydeRouteFromCityFound: t.union([t.undefined, t.boolean]),
  rydeRoutesToCityFound: t.union([t.undefined, t.boolean]),
  rydeRoutesFromSourceToDestinationFound: t.union([t.undefined, t.boolean])
});

export const CarTypeDataChecker = t.type({
  id: t.number,
  name: t.string,
  desciption: t.union([t.null, t.undefined, t.string])
});

export const CarTypeInfoDataChecker = t.type({
  vehicleModel: t.union([t.undefined, t.null, t.string]),
  luggage: t.union([t.undefined, t.null, t.string]),
  seats: t.union([t.undefined, t.null, t.number]),
  type: t.union([t.undefined, t.null, t.string])
});
export type CarTypeInfoData = t.TypeOf<typeof CarTypeInfoDataChecker>;

export type Package = { time: number; distance: number; package_id: string };

export type CityLocation = {
  city: string;
  subText: string;
  placeId: string;
  geoLocation?: SetFromPlace;
  cityCode?: string;
};

export const InterlinkInfo = t.type({
  text: t.string,
  url: t.union([t.undefined, t.string])
});
export const InterlinkBlockDataChecker = t.type({
  title: t.string,
  links: t.array(InterlinkInfo)
});

export type InterlinkBlock = t.TypeOf<typeof InterlinkBlockDataChecker>;
